import React, {useEffect, useState} from "react";
import {AContainer} from "@cisco-sbg-ui/magna-react";
import {useDispatch, useSelector} from "react-redux";
import {Outlet, useParams} from "react-router-dom";
import IncidentDetailsSection from "features/incidentDetail/IncidentDetailsSection";
import IncidentDetailTabs from "features/incidentDetail/IncidentDetailTabs";
import IncidentNotFound from "features/incidentDetail/IncidentNotFound";
import {IncidentDetailProvider} from "contexts/IncidentDetailContext";
import {
  clearIncidentDetail,
  getIncident
} from "store/features/incidentDetailSlice";
import {selectHasIncident, selectIncidentLoading} from "store/selectors";
import IncidentDetailSkeleton from "./IncidentDetailSkeleton";

const IncidentDetail = () => {
  const {id} = useParams();
  const dispatch = useDispatch();

  const loadingIncident = useSelector(selectIncidentLoading);
  const hasIncident = useSelector(selectHasIncident);

  const [incidentIdPresent, setIncidentIdPresent] = useState(false);

  useEffect(() => {
    if (id) {
      setIncidentIdPresent(true);
      dispatch(getIncident({id}));

      return () => {
        // Clear/Reset IncidentDetail store(s) when the page unloads.
        dispatch(clearIncidentDetail());
      };
    }
  }, [dispatch, id]);

  if (!incidentIdPresent) {
    return <IncidentDetailSkeleton />;
  }

  return loadingIncident ? (
    <IncidentDetailSkeleton />
  ) : (
    <AContainer
      className="incident-detail-page"
      data-testid={"IncidentDetail-Container"}
      fluid>
      <IncidentDetailProvider>
        {hasIncident && id ? (
          <>
            <IncidentDetailsSection />
            <IncidentDetailTabs />
            <Outlet />
          </>
        ) : (
          <IncidentNotFound id={id} />
        )}
      </IncidentDetailProvider>
    </AContainer>
  );
};

export default IncidentDetail;
